import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/common';

import { BlogFormComponent } from './blog-form.component';

@Injectable()
export class BlogFormDialog {
  readonly #dialog = inject(DialogService);

  open(): DialogRef {
    return this.#dialog.open(BlogFormComponent);
  }
}
